import { DISCOUNT_SUCCESS, SEND_ORDER_SUCCESS } from 'new-constants/api.constants';
import { STRIPE_SUCCESS, VIPPS_SUCCESS } from 'new-constants/payment.constants';
import { DONE_INCOMPATIBLE_CART_CONFIRMATION } from 'new-constants/popup.constants';
import { ServerValuesState } from './server-values.reducer.types';
import {
    CHECK_ADYEN_PAYMENT_SUCCESS,
    CHECK_PAYMENT_STATUS_SUCCESS,
    DISCOUNT_FAILURE,
    ORDER_SUCCESS, SUBMIT_APPLE_PAY_SUCCESS,
    SUBMIT_GOOGLE_PAY_SUCCESS
} from '../constants/api.constants';
import { PaymentStatuses } from "../constants/common.constants";
import { ADYEN_SUCCESS } from '../constants/payment.constants';

//TODO implement deliveryPrice
export const defaultServerValuesCacheEntry = {
	discountPrice: null,
	cashpointsAmount: null,
};

const initialState: ServerValuesState = {
	cache: {},
};

export const serverValuesReducer = (previousState = initialState, action): ServerValuesState => {
	switch (action && action.type) {
		case DISCOUNT_SUCCESS:
			return {
				...previousState,
				cache: {
					...previousState.cache,
					[action.payload.data.restaurantId]: {
						discountPrice: action.payload.data.discountPrice,
						cashpointsAmount: action.payload.data.cashPointsAmount,
					},
				},
			};
			break;

		case DISCOUNT_FAILURE:
			return {
				...previousState,
				cache: {
					...previousState.cache,
					[action.meta.restaurantId]: {...defaultServerValuesCacheEntry, itemsWillBeRemoved: !!action.meta.data.syncMenu?.removeEntryIdsFromCart}
				}
			};
			break;

		case SEND_ORDER_SUCCESS:
			if (action.payload.isOrderSent) {
				return {
					...previousState,
					cache: {
						...previousState.cache,
						[action.payload.data.order.restaurantId]: defaultServerValuesCacheEntry,
					},
				};
			}

			return previousState;
			break;

		case STRIPE_SUCCESS:
		case VIPPS_SUCCESS:
			return {
				...previousState,
				cache: {
					...previousState.cache,
					[action.restaurantId]: defaultServerValuesCacheEntry,
				},
			};
			break;
		case ADYEN_SUCCESS:
			if (action.payload.action.type === 'redirect' || action.payload.action.type === 'threeDS2' || action.payload.action.type === 'swish') {
				return {
					...previousState,
				}
			}
			return {
				...previousState,
				cache: {
					...previousState.cache,
					[action.restaurantId]: defaultServerValuesCacheEntry,
				},
			};
			break;

        case SUBMIT_GOOGLE_PAY_SUCCESS:
        case SUBMIT_APPLE_PAY_SUCCESS:
			if (action.payload.action.type === 'redirect' || action.payload.action.type === 'threeDS2') {
                return {
                    ...previousState,
                }
            }
            return {
                ...previousState,
                cache: {
                    ...previousState.cache,
                    [action.restaurantId]: defaultServerValuesCacheEntry,
                },
            };
            break;


		case CHECK_PAYMENT_STATUS_SUCCESS:
			if (!(action.payload.isAdyenOrder && action.payload.data.status === PaymentStatuses.complete)) {
				return previousState;
			}

			return {
				...previousState,
				cache: {
					...previousState.cache,
					[action.payload.currentRestaurantId]: defaultServerValuesCacheEntry,
				},
			};
			break;

		case CHECK_ADYEN_PAYMENT_SUCCESS:
			if (action.payload.data.resultCode !== PaymentStatuses.authorised) {
				return previousState;
			}

			return {
				...previousState,
				cache: {
					...previousState.cache,
					[action.payload.currentRestaurantId]: defaultServerValuesCacheEntry,
				},
			};
			break;

		case ORDER_SUCCESS:
			if (!(action.payload.isScheduledForCancel && action.payload.data.order.isPaid)) {
				return previousState;
			}

			return {
				...previousState,
				cache: {
					...previousState.cache,
					[action.payload.data.order.restaurantId]: defaultServerValuesCacheEntry,
				},
			};
			break;

		case DONE_INCOMPATIBLE_CART_CONFIRMATION:
			return {
				...previousState,
				cache: {
					...previousState.cache,
					[action.restaurantId]: defaultServerValuesCacheEntry,
				},
			};
			break;
	}

	return previousState;
};
